/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import Payment from '@/model/dataLayer/api/common/Payment'
import { onlineOrderFirebaseStore } from '@/model/dataLayer/api/takeaway/aaden-online-order-firebase'
import { collection, query, Timestamp, where } from 'firebase/firestore'
import { resultOf } from '@/model/firebase/queryUtils'
import dayjs from 'dayjs'

const entity = {
  tableName: {},
  createTimeDisplay: {
    displayName: 'createdAt'
  },
  deliveryMethod: {},
  deliveryTimeDisplay: {},
  discountStr: {
    displayName: 'discount'
  },
  paymentMethod: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Payment.getList,
        itemText: '_langsname'
      }
    },
    displayName: 'PaymentType'
  },
  totalPrice: {}
}
const config = {
  load: async function (filter) {
    const deviceId = await getCurrentStoreId()
    const [fromDateTime, toDateTime] = filter[0].dateFilter
    const res = query(collection(onlineOrderFirebaseStore, 'order'),
      where('deviceId', '==', deviceId), where('createTime', '>', Timestamp.fromDate(dayjs(fromDateTime).startOf('day').toDate())), where('createTime', '<=', Timestamp.fromDate(dayjs(toDateTime).endOf('day').toDate())))
    return (await resultOf(res))
      .map(it => {
        it.totalPrice = it.totalPrice.toFixed(2)
        it.createTimeDisplay = dayjs(it.createTime.seconds * 1000 + it.createTime.nanoseconds / 1000000).format('YYYY-MM-DD HH:mm:ss')
        it.deliveryTimeDisplay = dayjs(it.createTime.seconds * 1000 + it.createTime.nanoseconds / 1000000).format('YYYY-MM-DD HH:mm:ss')
        return it
      })
  }
}
export default IKDataEntity.ModelFactory(entity, config)
